module.exports = __webpack_public_path__ + "img/MBBANK.8abcbe7d.svg";